import { Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import DataCommon from "../ui/DataCommon";
import { Add, Edit } from "@mui/icons-material";
import FormText from "../form/FormText";
import FormSelect from "../form/FormSelect";
import { IFormEvent } from "../form/Form.interface";
import Util from "../services/util";

export default function ConfigMember() {

  const [query, setQuery] = useState({ limit: 20, skip: 0 })
  const [data, setData] = useState<{ count: number, data: any[] }>()
  const [form, setForm] = useState<any>()

  function find() {
    axios.post('system/memberlist', query).then(({ data }) => {
      setData(data);
    })
  }
  // eslint-disable-next-line
  useEffect(find, [])

  function handleFormChange(e: IFormEvent): void {
    setForm(Util.formChange(e, form))
  }

  function handleSave(): void {
    axios.post('system/memberSave', form).then(({ data }) => {
      setForm(undefined)
      find()
    })
  }

  return <Container>
    <Stack sx={{ mt: 2 }} direction="row">
      <Stack flexGrow={1}></Stack>
      <Button startIcon={<Add />} onClick={() => {
        setForm({ name: '', mobile: '', roles: ['审核员'] })
      }}>添加</Button>
    </Stack>
    {!!(data?.data?.length) && <Table>
      <TableHead>
        <TableRow>
          <TableCell>姓名</TableCell>
          <TableCell>电话</TableCell>
          <TableCell>权限</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.data.map((i, index) => <TableRow key={index}>
          <TableCell>
            {i.name}
          </TableCell>
          <TableCell>
            {i.mobile}
          </TableCell>
          <TableCell>
            {i.roles}
          </TableCell>
          <TableCell sx={{ p: 0 }}>
            <IconButton onClick={() => {
              setForm(i)
            }}><Edit /></IconButton>
          </TableCell>
        </TableRow>)}
      </TableBody>
    </Table>}
    <DataCommon data={data} query={query} setQuery={setQuery} />
    {form && <Dialog open onClose={() => setForm(undefined)}>
      <DialogTitle>{form._id ? '设置权限' : '新建'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <FormText label="姓名" name="name" value={form.name} onChange={handleFormChange} />
          <FormText label="手机" name="mobile" value={form.mobile} onChange={handleFormChange} />
          <FormSelect name={"roles"} value={form.roles} multiple label={"权限"}
            options={["超级管理员", "审核员"].map(i => ({ title: i, value: i }))}
            onChange={handleFormChange} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSave} >保存</Button>
      </DialogActions>
    </Dialog>}
  </Container>
}